"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
exports.__esModule = true;
exports.StatusPill = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var task_item_1 = require("@hiyllo/omni-common/src/types/tasks/task-item");
var select_1 = require("@hiyllo/ux/select");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var react_native_1 = require("react-native");
var platform_1 = require("@hiyllo/ux/platform");
var StatusColorMap = (_a = {},
    _a[task_item_1.TaskStatusColorEnum.amber] = "#f57c00",
    _a[task_item_1.TaskStatusColorEnum.blue] = "#1976d2",
    _a[task_item_1.TaskStatusColorEnum.gray] = "gray",
    _a[task_item_1.TaskStatusColorEnum.green] = "#388e3c",
    _a[task_item_1.TaskStatusColorEnum.red] = "#d32f2f",
    _a);
var STATUS_OPTIONS = task_item_1.DEFAULT_STATUSES.map(function (status) { return ({
    value: status.id,
    label: status.label
}); });
exports.StatusPill = react_1["default"].memo(function StatusPill(_a) {
    var status = _a.status, onChangeStatus = _a.onChangeStatus;
    var FontAwesomeIcon = (0, platform_1.useFontAwesomeIcon)();
    var selectedOption = STATUS_OPTIONS.find(function (o) { return o.value === status.id; });
    return ((0, jsx_runtime_1.jsx)(select_1.Select, { options: STATUS_OPTIONS, disabled: onChangeStatus === null, value: status.id, onChangeValue: function (id) {
            if (onChangeStatus != null) {
                onChangeStatus(task_item_1.DEFAULT_STATUSES.find(function (d) { return d.id === id; }));
            }
        }, containerStyle: { borderRadius: 5, width: 'auto' }, expandedContainerStyle: { borderRadius: 5 }, customStaticElement: (0, jsx_runtime_1.jsxs)(react_native_1.View, __assign({ style: {
                backgroundColor: StatusColorMap[status.color],
                paddingLeft: 5,
                paddingRight: 5,
                height: 25,
                borderRadius: 5,
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: 5
            } }, { children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, __assign({ style: {
                        color: "#ffffff",
                        fontSize: 12.5,
                        paddingLeft: 2.5,
                        paddingRight: onChangeStatus != null ? 0 : 2.5
                    } }, { children: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label })), onChangeStatus != null ? ((0, jsx_runtime_1.jsx)(FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faCaretDown, color: "white" })) : null] })) }));
});
